import React from "react";

const ArrowUp = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path
      d="M6 2.5L9.5 7H7v3H5V7H2.5L6 2.5z"
      fill="currentColor"
    />
  </svg>
);

const ArrowDown = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path
      d="M6 9.5L2.5 5H5V2h2v3h2.5L6 9.5z"
      fill="currentColor"
    />
  </svg>
);

const Dash = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path d="M2 6h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const formatValue = (value) => {
  if (value === null || value === undefined) return "—";
  if (typeof value !== "number") return value;
  if (Math.abs(value) >= 1_000_000) {
    return (value / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (Math.abs(value) >= 10_000) {
    return (value / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
  }
  return value.toLocaleString();
};

const Sparkline = ({ points, color }) => {
  if (!points || points.length < 2) return null;
  const w = 100;
  const h = 28;
  const max = Math.max(...points);
  const min = Math.min(...points);
  const range = max - min || 1;
  const step = w / (points.length - 1);
  const path = points
    .map((p, i) => {
      const x = i * step;
      const y = h - ((p - min) / range) * (h - 4) - 2;
      return `${i === 0 ? "M" : "L"} ${x.toFixed(2)} ${y.toFixed(2)}`;
    })
    .join(" ");
  const areaPath = `${path} L ${w} ${h} L 0 ${h} Z`;

  return (
    <svg
      className="rdc-kpi__spark"
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path d={areaPath} fill={color} fillOpacity=".1" />
      <path d={path} stroke={color} strokeWidth="1.5" fill="none" />
    </svg>
  );
};

const KpiTile = ({
  label,
  value,
  delta,
  deltaNote,
  trend,
  accent = "var(--rdc-brand-500)",
  loading = false,
}) => {
  const direction =
    delta === undefined || delta === null
      ? "flat"
      : delta > 0
      ? "up"
      : delta < 0
      ? "down"
      : "flat";

  const deltaIcon =
    direction === "up" ? <ArrowUp /> : direction === "down" ? <ArrowDown /> : <Dash />;

  return (
    <div className="rdc-kpi" role="figure" aria-label={`${label}: ${value}`}>
      <span className="rdc-kpi__label">{label}</span>
      {loading ? (
        <span
          className="rdc-skeleton"
          style={{ height: 36, width: "60%" }}
          aria-hidden="true"
        />
      ) : (
        <span className="rdc-kpi__value">{formatValue(value)}</span>
      )}
      <div className="rdc-kpi__footer">
        {delta !== undefined && delta !== null && !loading ? (
          <>
            <span className={`rdc-kpi__delta rdc-kpi__delta--${direction}`}>
              {deltaIcon}
              {Math.abs(delta).toFixed(1)}%
            </span>
            {deltaNote && (
              <span className="rdc-kpi__delta-note">{deltaNote}</span>
            )}
          </>
        ) : (
          <span className="rdc-kpi__delta-note">&nbsp;</span>
        )}
      </div>
      {trend && trend.length > 1 && !loading && (
        <Sparkline points={trend} color={accent} />
      )}
    </div>
  );
};

export default KpiTile;
